export const VolumeDownIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
  >
    <path
      d="M9 4C9 3.8078 8.88983 3.63261 8.71659 3.54935C8.54336 3.46609 8.33774 3.4895 8.18765 3.60957L5.82461 5.5H3.5C3.22386 5.5 3 5.72386 3 6V10C3 10.2761 3.22386 10.5 3.5 10.5H5.82461L8.18765 12.3904C8.33774 12.5105 8.54336 12.5339 8.71659 12.4507C8.88983 12.3674 9 12.1922 9 12V4Z"
      fill="#2C2543"
    />
    <path
      d="M12.0251 7.99997C12.0251 9.24261 11.5214 10.3676 10.7071 11.182L10 10.4748C10.6334 9.84147 11.0251 8.96647 11.0251 7.99997C11.0251 7.03348 10.6334 6.15848 10 5.5251L10.7071 4.81799C11.5214 5.63233 12.0251 6.75733 12.0251 7.99997Z"
      fill="#2C2543"
    />
  </svg>
);
